module.exports = __webpack_public_path__ + "05_hair_gold.b8889d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/05_hair_gold.png
// module id = nmt9
// module chunks = 0